import React, { useEffect } from "react";
import { Box, List, ListItem, ListItemIcon } from "@mui/material";
import Icon from "../../assets/group.png";
import SettingsIcon from "@mui/icons-material/Settings";
import { getUserProfile } from "../../api/user";

const MainSidebar = () => {
  // const [profile, setProfile] = useState({});
  
  const fetchProfileData = async () => {
    await getUserProfile();
    // setProfile(data);
  };

  useEffect(() => {
    fetchProfileData();
  }, []);

  return (
    <Box
      sx={{
        width: 60,
        display: "flex",
        flexDirection: "column",
        backgroundColor: '#f8f9fa',
        borderRight: 'none',
      }}
    >
      <List
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
          height: "95vh",
          padding: '8px 0',
        }}
      >
        <div>
          <ListItem 
            button
            sx={{
              borderRadius: '8px',
              margin: '0 4px',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
              },
            }}
          >
            <ListItemIcon>
              <img
                alt="setting"
                src={Icon}
                style={{ width: "30px", height: "30px" }}
              />
            </ListItemIcon>
          </ListItem>
          <ListItem 
            button
            sx={{
              borderRadius: '8px',
              margin: '4px',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
              },
            }}
          >
            <ListItemIcon>
              <div
                style={{
                  width: "35px",
                  height: "35px",
                  backgroundColor: "#E8EBF9",
                  borderRadius: "5px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <SettingsIcon sx={{ color: "#1D33C0" }} />
              </div>
            </ListItemIcon>
          </ListItem>
        </div>
        <div>
          <ListItem 
            button
            sx={{
              borderRadius: '8px',
              margin: '0 4px',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
              },
            }}
          >
            {/* <ListItemIcon>
              <Avatar alt="Remy Sharp" src={profile?.profile_picture} />
            </ListItemIcon> */}
          </ListItem>
        </div>
      </List>
    </Box>
  );
};

export default MainSidebar;
